import { render, staticRenderFns } from "./DeviceParamsItem.vue?vue&type=template&id=ced35308&scoped=true"
import script from "./DeviceParamsItem.vue?vue&type=script&lang=js"
export * from "./DeviceParamsItem.vue?vue&type=script&lang=js"
import style0 from "./DeviceParamsItem.vue?vue&type=style&index=0&id=ced35308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced35308",
  null
  
)

export default component.exports